<div class="col-md-8 no-padding">
    <h4>Zadaci koje pratite</h4>
</div>
<div class="col-md-4 no-padding text-right">
    <h4>Danas, {{date}} <i class="fa fa-arrow-down"></i></h4>
</div>
<div class="col-md-12 no-padding">
    <div class="well-done-notification-block no-margin row">

        <div class="wd-notif-blc-label col-md-4">
            Danas {{dateY}}
        </div>
        <div class="wd-notif-blc-sep-label col-md-8" style="text-align: end;font-size: 13px;">
            Ukupno: {{total}}
        </div>

        <div class="wd-notif-blc-item" *ngIf="total > 0"
             [ngStyle]="{'height': allWathcingTasks.length > 5 ? '400px':'200px'}">
            <ng-scrollbar #scrollable
                          [disableOnBreakpoints]="false">
                <div class="wd-notif-blc-item" *ngFor="let wat of allWathcingTasks">
                    <div [routerLink]="['/view-task',wat._id]"
                         class="wd-notif-blc-tasks col-md-12">
                        <div class="wd-task-list-title no-padding col-md-8 text-left ">
                            <span class="badge badge-secondary mr-1" *ngIf="wat.type==='task'">Zadatak</span>
                            <span class="badge badge-secondary mr-1" *ngIf="wat.type==='meeting'">Sastanak</span>
                            <span class="badge badge-secondary mr-1" *ngIf="wat.type==='note'">Bilješka</span>
                            <span class="badge badge-secondary mr-1" *ngIf="wat.type==='reminder'">Podsjetnik</span>
                            <div class="wd-task-color-badge meeting"></div>
                            <a [routerLink]="['/view-task',wat._id]"
                               style="cursor: pointer;color: black">{{wat.title}}</a>
                        </div>
                        <div class="col-md-2 text-right no-padding mt-1 float-right">
                            <i class="fa fa-calendar-alt mr-2"></i>
                            <i class="fa fa-map-marked-alt"></i></div>
                    </div>
                </div>
            </ng-scrollbar>
        </div>
        <div *ngIf="total == 0 " class="wd-notif-blc-item wd-notif-blc-sep-label" style="margin-top: 7px">
            Nema posmatranih taskova.
        </div>
    </div>
</div>


<div>
    <div class="col-md-8 no-padding mt-3">
        <h4 class="no-margin">Zadaci za odobravanje</h4>
    </div>
    <div class="col-md-12 no-padding">
        <div class="well-done-notification-block mt-0 row">

            <div class="wd-notif-blc-sep-label col-md-12" style="text-align: end;font-size: 13px;">
                Ukupno: {{totalForValid}}
            </div>

            <div class="col-md-12 no-padding" [ngStyle]="{'height': allTasksForValidation.length > 5 ? '400px':'200px'}"
                 class="wd-notif-blc-item" style="margin-bottom: 10px" *ngIf="totalForValid > 0">
                <ng-scrollbar #scrollable
                              [disableOnBreakpoints]="false">
                    <div class="wd-notif-blc-item" *ngFor="let task of allTasksForValidation">
                        <div class="wd-notif-blc-tasks col-md-12">
                            <div class="wd-task-list-title no-padding col-md-8 text-left ">
                                <span class="badge badge-secondary mr-1" *ngIf="task.type==='task'">Zadatak</span>
                                <span class="badge badge-secondary mr-1" *ngIf="task.type==='meeting'">Sastanak</span>
                                <span class="badge badge-secondary mr-1" *ngIf="task.type==='note'">Bilješka</span>
                                <span class="badge badge-secondary mr-1"
                                      *ngIf="task.type==='reminder'">Podsjetnik</span>
                                <div class="wd-task-color-badge meeting"></div>
                                <a [routerLink]="['/view-task',task._id]"
                                   routerLinkActive="active"
                                   style="cursor: pointer;color: black">{{task.title}}</a>
                            </div>
                            <div class="col-md-4 text-right no-padding mt-1 float-right">
                                <button style="background-color: transparent;border: none; box-shadow: none;outline:none;"
                                        (click)="validateTask(task, true)">
                                    <i style="color: mediumseagreen;font-size: 14px;"
                                       class="fa fa-check mr-2"
                                       aria-hidden="true"
                                    ></i>

                                </button>

                                <button style="background-color: transparent;border: none; box-shadow: none;outline:none;"
                                        (click)="validateTask(task,false)">
                                    <i style="color: red;font-size: 14px;"
                                       class="fa fa-times"
                                       aria-hidden="true"

                                    ></i>

                                </button>
                            </div>
                        </div>
                    </div>
                </ng-scrollbar>
            </div>
            <div *ngIf="totalForValid == 0 " class="wd-notif-blc-item wd-notif-blc-sep-label" style="margin-top: 7px">
                Nema taskova za odobravanje.
            </div>
        </div>
    </div>

</div>


